import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { DIFFERENTIATORS } from "@/data/content";

const SPANS = [
  "md:col-span-3 md:row-span-2",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
  "md:col-span-3",
];

const Card = ({ d, large }) => (
  <div className="group relative h-full overflow-hidden rounded-2xl border border-brand-ink/10 bg-white p-7 md:p-9 shadow-[0_10px_34px_-20px_rgba(16,42,90,0.30)] transition-all duration-500 hover:-translate-y-1 hover:border-brand-primary/30 hover:shadow-[0_22px_55px_-26px_rgba(20,102,214,0.45)]">
    <span className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-gradient-to-r from-brand-gold via-brand-primary to-brand-deepmagenta transition-transform duration-500 group-hover:scale-x-100" />
    <span className="flex h-12 w-12 items-center justify-center rounded-xl gradient-bg font-display text-lg font-black text-white shadow-md shadow-brand-primary/30">
      {d.num}
    </span>
    <h3 className={`mt-6 font-heading font-bold tracking-tight text-brand-ink ${large ? "text-2xl md:text-3xl" : "text-xl md:text-2xl"}`}>
      {d.title}
    </h3>
    <p className="mt-3 leading-relaxed text-brand-ink/75">{d.text}</p>
  </div>
);

export const BentoWhy = () => (
  <section className="relative noise-overlay" data-testid="why-section">
    <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12 py-14 md:py-24">
      <SectionHeading label="04 — Why Tangensis" title="Built on principles that drive results." />
      <div className="mt-10 md:mt-12 grid grid-cols-1 gap-4 md:grid-cols-6 md:auto-rows-fr">
        {DIFFERENTIATORS.map((d, i) => (
          <Reveal key={d.num} delay={(i % 3) * 0.08} className={SPANS[i] || "md:col-span-2"}>
            <Card d={d} large={i === 0} />
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
